import { create } from 'zustand'

interface UiState {
	sidebarOpen: boolean
	toggleSidebar: () => void
	setSidebarOpen: (open: boolean) => void
}

const isDesktop = () => window.matchMedia('(min-width: 768px)').matches

export const useUiStore = create<UiState>((set) => ({
	sidebarOpen: isDesktop(),

	toggleSidebar: () =>
		set((state) => ({ sidebarOpen: !state.sidebarOpen })),

	setSidebarOpen: (open) =>
		set({ sidebarOpen: open }),
}))
